import React from 'react';
import LogoSeal from '../assets/seal.png'
import LogoCha from '../assets/logo.png'
import { Header, Image } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { getApp } from '../store/slice/app.slice';
import { inWords } from '../utils/towords';
import { getDateTimeNow } from '../utils/constants';

export const RLPrint = React.forwardRef((props, ref) => {
    const { printData } = useSelector(getApp)
    const {
        NAME_LAST,
        NAME_FIRST,
        NAME_MIDDLE,
        ADDRESS_BRGY,
        TID,
        OUTPUT_HOSPITAL_NAME,
        OUTPUT_REFERRAL_AMOUNT,
        OUTPUT_REFERRAL_DOH_CODE,
        OUTPUT_REFERRAL_DOH_CODE_EXTENDED,
        OTHER_DATE,
        OTHER_REMARKS,
        BDAY_AGE,
        AGENCY_NAME,
        AGENCY_REFERRAL_AMOUNT,
        AGENCY_REFERRAL_REMARKS
    } = printData

    const formWhole = {"width":"816px","height":"1056px","border":"1px solid gray","fontFamily":"Lato"}
    const formSheet = {"width":"816px","height":"528px","position":"relative","border":"1px solid gray"}
    const logoCalamba = {"width":"5.5rem","position":"absolute","margin":"0rem 2rem"}
    const logoCha = {"width":"5.5rem","position":"absolute","margin":"0rem 2rem", "right":"0"}
    const body = {"marginTop": "1rem", "textAlign":"justify","padding": "0rem","margin":"3rem", "borderRadius": "0.5rem"}
    const head = {"marginTop": "1rem", "marginBottom": '2rem'}
    const r = {"textAlign":"center"}
    const equateOne = {"textAlign":"left","margin":"0rem 2rem","fontSize":"12px"}
    const fieldRow = {"marginTop":"0.5rem", "textAlign":"left"}
    const fieldRowR = {"marginTop":"0.5rem", "textAlign":"right"}
    const fieldA = {"fontSize":"15px","fontWeight":"bolder"}
    const fieldRow1 = {"paddingTop":"0.5rem", "textAlign":"justify"}
    const titleHead = {"fontWeight":"bolder","fontSize":"25px", "textAlign": 'center'}
    const tableStyle = {"border":"1px solid black", "width": "100%", borderCollapse: 'collapse'}
    const trStyle = {"border":"1px solid black", "padding": '0.3rem'}
    const logoSeal = {"width":"5rem","position":"absolute","margin":"0rem 2rem", "left":"3rem"}

    const formatDate = (d) => {
        // For dates that have time
        if(d && d.length >= 10){
            return d
        }else{
            return d ? d.substring(0, d.indexOf(' ')) : ''
        }
    }

    const renderRFForm = (copyNum) =>{
        return (
            <div className="form-sheet" style={formSheet}>
                <div className="head" style={head}>
                <br/>
                <Image src={LogoCha} className="logo-calamba" style={logoCha}></Image>
                <Image src={LogoSeal} className="logo-calamba" style={logoSeal}></Image>
                </div>
            <div className="body" style={body}>
                <div className="equate-one" style={equateOne}>
                    <div className="field-row" style={fieldRow}>
                    <br/><br/>
                        <div className="field-a" style={titleHead}>REFERRAL LETTER</div>
                    </div>
                    <div className="field-row" style={fieldRowR}>
                    <br/>
                        <div className="field-a" style={fieldA}>{formatDate(OTHER_DATE)}</div>
                    </div>
                    <div className="letter-proper" style={{textAlign:'left', fontSize:'15px', marginTop: '1rem'}}>
                        <div className="field-q" style={fieldRow1} >
                        
                        Respectfully referred to <u><b>{`${AGENCY_NAME}`}</b></u> for <b><u>{`${AGENCY_REFERRAL_REMARKS}`}</u></b> of <br/><u><b>{`  ${NAME_LAST}, ${NAME_FIRST} ${NAME_MIDDLE}`}{`, ${BDAY_AGE} y/o`}</b></u>
                        {`${` from `}`}
                        <u><b>{`${ADDRESS_BRGY} Calamba City Laguna`} </b></u>
                        <br/>amounting to
                        {
                            AGENCY_REFERRAL_AMOUNT ? (
                                <>
                                {` `}
                                    <b>{`Php ${AGENCY_REFERRAL_AMOUNT}`}</b>&ensp;
                                    <u><b>{`( ${inWords(AGENCY_REFERRAL_AMOUNT)} pesos )`}</b></u>
                                    {` `}
                                </>
                            ) : (
                                <>
                                    {` `}
                                    <u><b>{`Php _____________`}</b></u>&ensp;
                                    <u><b>{`, __________________________________________________________ pesos `}</b></u>
                                    {` `}
                                </>
                            )
                        }
                        with referral number <u><b>{`${TID}`}</b></u>.

                        </div>
                    <div className="field-row" style={fieldRow}>
                        <br/><br/>
                        <div className="field-q">Verified by</div>
                        <br/><br/>
                        TRIXIE MAE C. MAIQUEZ<br/>
                        <i>District Office Supervisor</i>
                        <br/><br/><br/>
                        <div className="field-q"><i>{`Copy ${copyNum} of Transaction Number: ${TID}`}</i></div>
                    </div>
                </div>
                {/* <div style={{textAlign: "left", marginTop:'5rem', fontSize:"10px", backgroundColor: "#fcd520", padding: '1rem 2rem', borderTop: '1rem solid gray'}}>
                    THIS DOCUMENT IS SYSTEM GENERATED.<br/>
                    <b>Validity is one (1) month from the date of the issuance.</b>
                    <br/>
                    <i>Copy {copyNum}</i>
                </div> */}
                </div> 
            </div>
            </div>
        )
    }

    return (
        <div style={formWhole} id="intshtz" ref={ref} >
            {renderRFForm(1)}
            {renderRFForm(2)}
        </div>
    );
  });